import { useIntegrationsRoot } from 'modules/Integrations/view/useIntegrations.root'
import { IntegrationsProvider } from 'modules/Integrations/communication'
import { ReactNode } from 'react'

export const IntegrationsRoot = (props: { children: ReactNode }) => {
  const { domain } = useIntegrationsRoot()

  return (
    <IntegrationsProvider value={domain}>{props.children}</IntegrationsProvider>
  )
}
